import WrapperLayout from 'components/Layout';
import Main from "./Components/Main"
const PlaybookRecommender = () =>{
    return(
        <>
        <WrapperLayout>
            <Main/>
        </WrapperLayout>
    </>
    )
}
export default PlaybookRecommender